import { render, staticRenderFns } from "./OrderInfoPickup.vue?vue&type=template&id=5e6b39e2&scoped=true&"
import script from "./OrderInfoPickup.vue?vue&type=script&lang=js&"
export * from "./OrderInfoPickup.vue?vue&type=script&lang=js&"
import style0 from "./OrderInfoPickup.vue?vue&type=style&index=0&id=5e6b39e2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e6b39e2",
  null
  
)

export default component.exports